/**
 * Mirrors `engine/src/activities/constants.ts` — names used as character variable keys.
 * Duplicated here so the Vite/Rollup bundle does not rely on CJS named export interop from coop-adventure-engine.
 */
export const CHARACTER_ACTIVITIES_IN_PROGRESS_VAR = 'character_activities_in_progress';
export const CHARACTER_ACTIVITIES_COMPLETED_VAR = 'character_activities_completed';
export const CHARACTER_ACTIVITY_RESUME_SCENES_VAR = 'character_activity_resume_scenes';
